import * as React from 'react';
import {
    Card,
    Box,
    Stack,
    Typography,
    IconButton,
    Tooltip,
} from '@mui/material';
import { useGetList, SimpleList } from 'react-admin';
import { MemberAvatar } from '../member/show/MemberAvatar';
import { getFullName } from '@domain/member';
import { MemberSummary } from '@wwf/sdk';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { Link } from 'react-router-dom';
import { MemberIcon } from '@app/member/MemberIcon';

export const HotMembers = () => {
    const {
        data: memberData,
        total: memberTotal,
        isPending: memberLoading,
    } = useGetList<MemberSummary>('member', {
        pagination: { page: 0, perPage: 10 },
        sort: { field: 'last_seen', order: 'DESC' },
        filter: { status: 'hot' },
    });

    return (
        <Stack>
            <Box display="flex" alignItems="center" mb={1}>
                <Box mr={1} display="flex">
                    <MemberIcon />
                </Box>
                <Typography variant="h5" color="textSecondary">
                    Hot Members
                </Typography>
                <Tooltip title="Create member">
                    <IconButton
                        size="small"
                        sx={{
                            color: 'text.secondary',
                            ml: 'auto',
                        }}
                        component={Link}
                        to="/member/create"
                    >
                        <ControlPointIcon fontSize="inherit" color="primary" />
                    </IconButton>
                </Tooltip>
            </Box>
            <Card
                sx={{
                    '& .MuiCardContent-root': {
                        padding: '16px !important',
                    },
                }}
            >
                <SimpleList<MemberSummary>
                    rowClick="show"
                    resource="member"
                    data={memberData}
                    total={memberTotal}
                    isPending={memberLoading}
                    primaryText={member => getFullName(member)}
                    secondaryText={member => (
                        <>
                            {member.type} at{' '}
                            {member.antennas
                                ?.map(antenna => antenna.name)
                                .join(', ')}
                        </>
                    )}
                    leftAvatar={member => <MemberAvatar record={member} />}
                    dense
                    empty={
                        <Box p={2}>
                            <Typography variant="body2" gutterBottom>
                                Member with a "hot" status will appear here.
                            </Typography>
                            <Typography variant="body2">
                                Change the status of a member on his/her page.
                            </Typography>
                        </Box>
                    }
                />
            </Card>
        </Stack>
    );
};
